import request from "./../utils/request";

export function getSingleAnnouncement(id) {
    return request.get("/announcements/" + id, {});
}

export function getAnnouncements(perPage = 25, page = 1, isLast = false) {
    return request.get("/announcements/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
            isLast: isLast,
        },
    });
}

export function createAnnouncement(data) {
    return request({
        url: "/announcements/",
        method: "post",
        data: data,
    });
}

export function updateAnnouncement(id, data) {
    return request.put(`/announcements/${id}`, data);
}

export function deleteAnnouncement(id) {
    return request.delete(`/announcements/${id}`);
}
